import React from 'react';
import './EventPopup.css';

const EventPopup = ({ event, referenceElement, onClose, onDelete }) => {
  if (!event) return null;

  const handleDelete = () => {
    if (window.confirm('Are you sure you want to delete this shift?')) {
      const eventId = event.extendedProps.uid || event.id;
      onDelete(eventId);
    }
  };

  return (
    <div className="event-popup-overlay" onClick={onClose}>
      <div className="event-popup" onClick={(e) => e.stopPropagation()}>
        <div className="event-popup-header">
          <h3>Shift Details</h3>
          <button className="event-popup-close" onClick={onClose}>×</button>
        </div>
        
        <div className="event-popup-content">
          <div className="event-detail">
            <span className="event-label">Doctor:</span>
            <span className="event-value">{event.extendedProps.doctor_name} ({event.extendedProps.location})</span>
          </div>
          
          <div className="event-detail">
            <span className="event-label">Date:</span>
            <span className="event-value">{event.start.toLocaleDateString('en-US', { 
              weekday: 'long', 
              year: 'numeric', 
              month: 'long', 
              day: 'numeric' 
            })}</span>
          </div>
          
          <div className="event-detail">
            <span className="event-label">Location:</span>
            <span className="event-value">{event.extendedProps.location}</span>
          </div>
          
          <div className="event-detail">
            <span className="event-label">Duration:</span>
            <span className="event-value">{event.extendedProps.shift_time}</span>
          </div>
          
          <div className="event-detail">
            <span className="event-label">Status:</span>
            <span className={`event-status ${event.extendedProps.conflict ? 'conflict' : 'no-conflict'}`}>
              {event.extendedProps.conflict ? '⚠️ CONFLICT' : '✅ NO CONFLICTS'}
            </span>
          </div>
        </div>
        
        <div className="event-popup-actions">
          <button className="event-action-btn event-delete-btn" onClick={handleDelete}>
            🗑️ Delete Shift
          </button>
          <button className="event-action-btn event-close-btn" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default EventPopup;
